module.exports = __webpack_public_path__ + "3577c6c49aad30823abd8e3c17771284.svg";